import type { ISocketAck, Socket } from '~/@types'
import io from 'socket.io-client'
import { logger } from './logger'

let socket: Socket

export function createSocket() {
  socket = io(import.meta.env.VITE_SOCKET_URL, {
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    transports: ['websocket'],
  }) as unknown as Socket
  return socket
}

export function socketAck(data: any, ack?: ISocketAck) {
  if (!ack) {
    logger.info('[WS] No ack function provided')
    return
  }

  try {
    ack({ messageId: data?._meta?.messageId, status: true })
  }
  catch (error) {
    logger.error('[WS] Error calling ack', error)
  }
}
